import type { FormEventHandler, ReactNode } from 'react';

import styles from './AuthCard.module.less';

export type AuthCardProps = {
  /** Fired on form submit (Enter or the submit button). The card handles `preventDefault`. */
  onSubmit: () => void;
  children: ReactNode;
};

/**
 * The white auth form card. It owns the `<form>` element and its `preventDefault`, so each page passes a single
 * `onSubmit`.
 */
const AuthCard = ({ onSubmit, children }: AuthCardProps) => {
  const handleSubmit: FormEventHandler = event => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form className={styles.card} onSubmit={handleSubmit}>
      {children}
    </form>
  );
};

export default AuthCard;
